export var Type;
(function (Type) {
    /** Specifies that this enum wasn't sent. Should never happen in production. */
    Type["UNDEFINED"] = "UNDEFINED";
    Type["DESKTOP"] = "DESKTOP";
    Type["MOBILE"] = "MOBILE";
    Type["VIDEO"] = "VIDEO";
    Type["DESKTOP_16X9"] = "DESKTOP_16X9";
    Type["RESPONSIVE_TALL"] = "RESPONSIVE_TALL";
    Type["FLEXIBLE"] = "FLEXIBLE";
})(Type || (Type = {}));
export var TemplateBuilder;
(function (TemplateBuilder) {
    TemplateBuilder["Editor"] = "Editor";
    TemplateBuilder["EditorX"] = "EditorX";
    TemplateBuilder["Adi"] = "Adi";
    TemplateBuilder["Studio"] = "Studio";
})(TemplateBuilder || (TemplateBuilder = {}));
export var TemplatePrice;
(function (TemplatePrice) {
    TemplatePrice["UNDEFINED"] = "UNDEFINED";
    TemplatePrice["FREE"] = "FREE";
    TemplatePrice["ECOM"] = "ECOM";
    TemplatePrice["HOTELS"] = "HOTELS";
    TemplatePrice["PRO"] = "PRO";
})(TemplatePrice || (TemplatePrice = {}));
//# sourceMappingURL=types.impl.js.map